import {
  plainMurnAddressFromFormkit,
  plainMurnAddressToFormkit,
  murnAddressToFormkit,
  murnAddressFromFormkit,
} from "@modernary/mui/components/fk";

import { type Facility, type FacilityNew } from "@/views/facility/facility";
import { fillAddressLookupValues, fillPrefixedAddressLookupValues } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  fromFormkit,
  toFormkit,
  skinnyResponseAdapter,
  responseAdapter,
};

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Facility }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Facility }) {
  await skinnyResponseAdapter(response);
  await fillAddressLookupValues(response.data);
  return response.data;
}

function addAuthRequestFields(entity: Facility | FacilityNew) {
  entity._authRequestFields = ["id", "statusMurn"] as (keyof Facility)[];
  return entity;
}

function getInitialData() {
  const result = {} as Facility; //TODO:TS
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Facility) {
  plainMurnAddressToFormkit(data);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {
  plainMurnAddressFromFormkit(data as Facility);
}
